import React from "react";

import { Button, message, Modal, Space, Table, Typography } from "antd";
import Text from "antd/lib/typography/Text";
import { useDispatch, useSelector } from "react-redux";
import {
  AddDesignations,
  deleteDesignations,
  DeleteDesignations,
  getDesignations,
} from "../../../../actions/companySettings";
import AddNewIcon from "../../../../assets/icons/add_new_white.png";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import { hasAccess, objectToFormData } from "../../../../utils";
import PageHeader from "../../../PageHeader";
import AddGrades from "./AddGrade";

const { Title } = Typography;

const columns = [
  {
    title: "User Title",
    dataIndex: "title",
    key: "title",
    render: (text, data) => {
      return (
        <div className={`render_common_style status_${data?.Status}`}>
          {text}
        </div>
      );
    },
  },
  {
    title: "User Grade/Level",
    dataIndex: "grade_levels",
    key: "grade_levels",
    render: (val) => val.length && val.join(", "),
  },
];

message.config({
  maxCount: 3,
});

const Grades = () => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setIsModalType] = React.useState("center");
  const [selectedId, setSelectedId] = React.useState("");
  // const [permissionsData, setPermissionsData] = React.useState({});
  const [designationsData, setDesignationsData] = React.useState([]);
  // const rolesPermissionResponse = useSelector(state => state.companySetting.getGradesPermissions || {});
  const getDesignationsResponse = useSelector(
    (state) => state.companySetting.getDesignations || {},
  );
  const addDesignationsResponse = useSelector(
    (state) => state.companySetting.addDesignations || {},
  );
  const deleteDesignationsResponse = useSelector(
    (state) => state.companySetting.deleteDesignations || {},
  );

  const tableAction = [
    hasAccess("users_and_controls", "write")
      ? {
          title: "Actions",
          key: "action",
          render: (text, record) => (
            <Space key={record.id} size="middle">
              <button
                onClick={(e) => {
                  showEditModal(record.id);
                }}
              >
                <img src={EditIcon} alt={"logo"} className="action-logo" />
              </button>
              <button
                onClick={(e) => {
                  showDeleteModal(record.id);
                }}
              >
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />
              </button>
            </Space>
          ),
        }
      : {},
  ];

  React.useEffect(() => {
    // dispatch(getGradesPermissions({}));
    dispatch(getDesignations({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: { response: { designations = {} } = {}, status = false } = {},
    } = getDesignationsResponse;
    if (status) {
      setDesignationsData(designations);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDesignationsResponse]);

  React.useEffect(() => {
    const {
      data: { message: res_message = "", status = "", errors = "" } = {},
    } = addDesignationsResponse;
    if (status) {
      // if (selectedId)
      //   message.success(<span className="messageText">{res_message?.replace("saved", "updated")}</span>);
      // else
      //   message.success(<span className="messageText">{res_message}</span>);
      setIsModalVisible(false);
      dispatch(getDesignations({}));
      dispatch({
        type: AddDesignations.RESET,
      });
    }
    if (status === false) {
      dispatch({
        type: AddDesignations.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addDesignationsResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      deleteDesignationsResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch(getDesignations({}));
      dispatch({
        type: DeleteDesignations.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteDesignationsResponse]);

  const showModal = () => {
    setSelectedId("");
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const showDeleteModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("center");
  };

  const showEditModal = (id) => {
    setSelectedId(id);
    setIsModalVisible(true);
    setIsModalType("right");
  };

  const renderDeleteOption = () => {
    return (
      <>
        <Text>Are you sure about deleting this Grade/Designation?</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(deleteDesignations(objectToFormData({ id: selectedId })))
          }
        >
          Delete
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  function handleButtonClick(e) {
    showModal();
  }

  return (
    <>
      {isModalVisible && (
        <Modal
          title={
            modalType === "center" ? (
              <>
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />{" "}
                Delete Grade
              </>
            ) : (
              <Title level={4}>
                {selectedId ? "Edit Grade" : "New Grade"} &nbsp;
                <span className="text-small">Enter details and submit</span>
              </Title>
            )
          }
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className={
            modalType === "center"
              ? "center-aligned-modal"
              : "right-alinged-modal-small"
          }
        >
          {modalType === "center" ? (
            renderDeleteOption()
          ) : (
            <AddGrades id={selectedId} handleCancel={handleCancel} />
          )}
        </Modal>
      )}
      <div className="heading-div">
        <PageHeader
          title={`Grades & Designations`}
          navigation={{
            Home: "/dashboard/",

            "Grades & Designations": null,
          }}
        />
      </div>
      {hasAccess("users_and_controls", "write") && (
        <Button
          onClick={handleButtonClick}
          className="mb1 ml1 addNew primaryButton"
        >
          <img src={AddNewIcon} alt={"logo"} className="addNew-logo" />
          Add New
        </Button>
      )}
      <Table
        rowKey="id"
        columns={[...columns, ...tableAction]}
        dataSource={designationsData}
        className="settingsTable"
      />
    </>
  );
};

export default Grades;
